import Cookies from 'js-cookie'
import moment from "moment";

export const rootPrefix = ''

export const getRouterBasename = () => {
  if (process.env.REACT_APP_ROUTER_BASENAME) {
    return process.env.REACT_APP_ROUTER_BASENAME;
  }
  const appSubpath = Cookies.get('app_subpath');
  if (appSubpath && appSubpath !== '/---') {
    return appSubpath;
  }
  const firstPathSegment = window.location.pathname.split('/').filter(Boolean)[0];
  return firstPathSegment ? `/${firstPathSegment}` : (rootPrefix || '/');
}

export const addPlural = (val) => val > 1 ? 's' : '';

export const objectToQueryString = (obj) => {
  const objKeys = Object.keys(obj);
  return objKeys.length > 0 
    ? objKeys.map(key => key + '=' + obj[key]).join('&')
    : ''
} 

export const allowedClientSubdomains = []

const allowedStandardDomains = ['hub', 'jobs', process.env.REACT_APP_API_URL || 'localhost:3000']
const allAllowedSubDomains = [ ...allowedClientSubdomains, ...allowedStandardDomains ]

export const getClientSubdomain = () => {
  const originFull = window.origin;
  const splitVal = originFull.indexOf('https://') > -1 ? 'https://' : 'http://';
  const origin = originFull.split(splitVal)[1] || '';
 
  const parts = origin.split('.');
  const firstPart = parts[0];

  if (process.env.REACT_APP_SUBDOMAIN_ENV) {
    return process.env.REACT_APP_SUBDOMAIN_ENV
  }
  else if (allAllowedSubDomains.indexOf(firstPart) > -1) {
    return firstPart
  }
  else {
    return ''
  }
}

export const isDevMode = () => {
  return (window.location.host.indexOf('localhost') > -1)
    || (getRouterBasename() === '/')
}

export const getEnv = () => {
  const host = window.location.host;

  // Always use qa if in a localhost environment
  if (host.indexOf('localhost') > -1) {
    return 'qa'
  } else {
    // detect env
    const parts = host.split('.');
    // Only qa/uat are real environments; any other segment before 'prosolve.com' means prod
    const envPart = parts[parts.length-3];
    const env = ['qa', 'uat'].includes(envPart) ? envPart : '';
    return env;
  }
}

// export const checkHasEditEventPermissions = () => {
//   const adminPermissionsCookies = Cookies.get('adminPermissions') || ''
//   return (adminPermissionsCookies.indexOf('EVENTS_EDIT') > -1)
// }

export const copySvgToClipboardAsImage = async (svgElement) => {
  const svgText = new XMLSerializer().serializeToString(svgElement);
  const svgBlob = new Blob([svgText], { type: 'image/svg+xml' });
  const url = URL.createObjectURL(svgBlob);

  const img = new Image();
  img.src = url;

  img.onload = async () => {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);

    canvas.toBlob(async (blob) => {
      try {
        await navigator.clipboard.write([
          new ClipboardItem({ [blob.type]: blob })
        ]);
        console.log('SVG copied as image!');
      } catch (err) {
        console.error('Failed to copy SVG as image:', err);
      }
    });
  };
}

export const includesSome = (str, arr) => {
  return arr.some(a => str?.includes(a))
}

export const formatDate = (date) => {
  const mDate = moment(date)
  return mDate.isValid() ? mDate.format('L') : ''
}
